export default "__VITE_ASSET__605467c4__"